export const demographicKeys = {
  all: ['demographics'] as const,

  lists: () => [...demographicKeys.all, 'list'] as const,

  gender: () => [...demographicKeys.lists(), 'gender'] as const,
  pronouns: () => [...demographicKeys.lists(), 'pronouns'] as const,
  ethnicity: () => [...demographicKeys.lists(), 'ethnicity'] as const,
  sexualOrientation: () => [...demographicKeys.lists(), 'sexualOrientation'] as const,

  detail: (id: string) => [...demographicKeys.lists(), id] as const,
};
